import { useEffect, useState } from 'react'

import type { Section } from '../../types'

const SECTIONS_LOAD_PER_TIME = 3
const SECTIONS_LOAD_TIMEOUT = 1500

const getPartitionedSections = (initialSections: readonly Section[]) => [
  initialSections.slice(0, SECTIONS_LOAD_PER_TIME),
]

export const usePartitionedSections = (initialSections: readonly Section[]) => {
  const [partitionedSections, setPartitionedSections] = useState<Section[][]>(
    () => getPartitionedSections(initialSections)
  )

  useEffect(() => {
    let getNextSectionsTimeout: ReturnType<typeof setTimeout>

    const getNextSections = (startIndex: number, endIndex: number) => {
      const nextSections = initialSections.slice(startIndex, endIndex)

      if (nextSections.length === 0) return

      getNextSectionsTimeout = setTimeout(() => {
        setPartitionedSections((prevPartitionedSections) => [
          ...prevPartitionedSections,
          [...nextSections],
        ])

        getNextSections(endIndex, endIndex + SECTIONS_LOAD_PER_TIME)
      }, SECTIONS_LOAD_TIMEOUT)
    }

    getNextSections(
      SECTIONS_LOAD_PER_TIME,
      SECTIONS_LOAD_PER_TIME + SECTIONS_LOAD_PER_TIME
    )

    return () => {
      clearTimeout(getNextSectionsTimeout)
    }
  }, [initialSections])

  useEffect(() => {
    setPartitionedSections(() => getPartitionedSections(initialSections))
  }, [initialSections])

  return {
    partitionedSections,
  }
}
